import styled from 'styled-components';
import { Calendar, ClearIcon } from '../../../icons';

export const Container = styled.div`
  top: 0;
  position: absolute;
  right: 1rem;
  color: ${({ theme }) => theme.colors.lightBlue};
  height: 45.5px;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  pointer-events: all;
`;

export const Wrapper = styled.div`
  display: flex;
  align: center;
  cursor: pointer;

  & > svg {
    fill: ${({ theme }) => theme.colors.lightBlue};
  }
`;

export const ClearAction = styled(ClearIcon)`
  height: 15px;
  padding-right: 0.5rem;
  margin-top: 3px;
`;

export const CalendarAction = styled(Calendar)`
  height: 18px;
`;
